export default {
  async time() {
    const serverTime = await fetch(window.location, {
      cache: `no-store`,
      method: `HEAD`
    });
    return serverTime.headers.get("Date");
  }
};
